import $ from 'jquery';
import 'bootstrap-slider';

const FUNDING_TYPE_LONG_TERM_LEASING = 'long_term_leasing';
const FUNDING_TYPE_LEASING_WITHOUT_REPURCHASE_COMMITMENT = 'leasing_without_repurchase_commitment';
const FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT = 'leasing_with_repurchase_commitment';
const FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT = 'loan_without_repurchase_commitment';
const FUNDING_ORGANISM_CAPITOLE_FINANCE = 'capitole_finance';
const FUNDING_ORGANISM_FINANCO = 'financo';

var ajaxObjectList = {};
var callMakeAllSimulations = null;
var propositions = {};

let $apport = null;
let $prixDeVenteTotalWithPromo = null;
let $prixDeVenteTotal = null;
let $prixVehiculeEmotors = null;
let $prixOptions = null;
let $prixCouleurInterieure = null;
let $prixCouleurExterieure = null;
let $fundingInfosDiv = null;
let $chosenFundingPropositionBtn = null;



export default class Funding{

    static displayBestFundingPriceByMonth() {
        var $bestFundingPriceByMonth = $('#bestFundingPriceByMonth');
        let bestProposition = null;
        $.each(propositions, function (index, object) {
            if (typeof object !== 'undefined'){
                if (bestProposition !== null ){
                    if (object.monthlyPayment < bestProposition.monthlyPayment){
                        bestProposition = object;
                    }
                } else {
                    bestProposition = object;
                }
            }
        });

        if (bestProposition !== null) {
            $bestFundingPriceByMonth.parent().css('display', 'block');
            $bestFundingPriceByMonth.html(Math.round(bestProposition.monthlyPayment) + ' &euro; <span class="small-5">/ mois</span>');
            $('#legalInfosBestPrice').attr('data-original-title', bestProposition.legalInfos)
        }
        else {
            $bestFundingPriceByMonth.parent().css('display', 'none');
        }

        Funding.hideLoader($bestFundingPriceByMonth.closest('.info-price'), '#containerBestFundingPrice');
    }

    static makeLLDSimulation(){
        Funding.showBestPriceLoading();
        Promise.all([Funding.makeSimulation(FUNDING_TYPE_LONG_TERM_LEASING, FUNDING_ORGANISM_CAPITOLE_FINANCE)]).then( value => {

            Funding.displayBestFundingPriceByMonth();
        });
    }

    static makeLOASimulation(){
        Funding.showBestPriceLoading();
        Promise.all([Funding.makeSimulation(FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT, FUNDING_ORGANISM_FINANCO)]).then( value => {

            Funding.displayBestFundingPriceByMonth();
        });
    }

    static makeLOANSimulation(){
        Funding.showBestPriceLoading();
        Promise.all([Funding.makeSimulation(FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT, FUNDING_ORGANISM_FINANCO)]).then( value => {
            Funding.displayBestFundingPriceByMonth();
        });
    }

    static makeAllSimulations() {

        if (callMakeAllSimulations !== null) {
            clearTimeout(callMakeAllSimulations);
        }
        callMakeAllSimulations = setTimeout(function () {
            Funding.makeAllSimulationsCall();
            callMakeAllSimulations = null;
        }, 500);
    }

    static showBestPriceLoading() {
        Funding.showLoader($('#bestFundingPriceByMonth').closest('.info-price'), '#containerBestFundingPrice');
    }

    static makeAllSimulationsCall() {
        Funding.showBestPriceLoading();

        let promises = [];

        if ($fundingInfosDiv.data('enable-' + FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT)) {
            promises.push(Funding.makeSimulation(FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT, FUNDING_ORGANISM_FINANCO));
        }

        if ($fundingInfosDiv.data('enable-' + FUNDING_TYPE_LONG_TERM_LEASING)) {
            promises.push(Funding.makeSimulation(FUNDING_TYPE_LONG_TERM_LEASING, FUNDING_ORGANISM_CAPITOLE_FINANCE));
        }

        if ($fundingInfosDiv.data('enable-' + FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT)) {
            promises.push(Funding.makeSimulation(FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT, FUNDING_ORGANISM_FINANCO));
        }

        if (promises.length > 0) {
            Promise.all(promises).then(() => {
                Funding.displayBestFundingPriceByMonth();
            }).catch();
        }
    }

    /**
     * Must return purchase Amount by FundingType
     * @param fundingType
     * @returns {number}
     */
    static getPurchaseAmount(fundingType){
        return Number($prixVehiculeEmotors.data('price'));
    }

    /**
     * @param fundingType
     * @param fundingOrganization
     */
    static makeSimulation(fundingType, fundingOrganization) {
        var $card = $('#proposition-' + fundingType);
        Funding.showLoader($card);
        $card.find('.bloc-monthyPayment').hide();
        $card.find('.info-error').hide();
        var data = Funding.getFundingRequestData(fundingType, fundingOrganization);

        return Funding.makeSimulationRequest(fundingType, data);
    }

    /**
     *
     * @param fundingType
     * @param fundingOrganization
     * @returns {{depositAmount: (*|jQuery|*|*|*|*), duration: (*|jQuery|*|*|*|*), annualMileage: (*|jQuery|*|*|*|*), fundingType: *, borrowerInsurance: (*|jQuery|*|*|*|*), propertyInsurance: (*|jQuery|*|*|*|*), fundingOrganization: *, vehicleId: (jQuery|*|*|*|*|*), coBorrowerInsurance: (*|jQuery|*|*|*|*), selectedOptionPrice: number, purchaseAmount: number}}
     */
    static getFundingRequestData(fundingType, fundingOrganization){
        let duration = $('#financementDuree-' + fundingType).val();
        let kmAnnuel = $('#financementAnnualMileAge-' + fundingType).val();
        let depositAmount = $('#financementApport').val();
        let carId = $fundingInfosDiv.attr('data-car-id');
        //let prixOptions = parseInt($prixOptions ? $prixOptions.html().replace(' ', '') : 0, 0);
        let borrower = $('#borrower-insurance-' + fundingType).data('borrower-insurance');
        let coborrower = $('#coborrower-insurance-' + fundingType).data('coborrower-insurance');
        let property = $('#property-insurance-' + fundingType).data('property-insurance');
        let purchaseAmount = Funding.getPurchaseAmount(fundingType);

        return {
            vehicleId: carId,
            purchaseAmount: purchaseAmount,
            depositAmount: depositAmount,
            duration: duration,
            annualMileage: kmAnnuel,
            fundingType: fundingType,
            fundingOrganization: fundingOrganization,
            borrowerInsurance: borrower,
            coBorrowerInsurance: coborrower,
            propertyInsurance: property,
            selectedOptionPrice: 0
        };
    }

    /**
     *
     * @param fundingType
     * @param data
     * @returns {Promise<any>}
     */
    static makeSimulationRequest(fundingType, data){
        return new Promise((resolve, reject) => {
            var url = $fundingInfosDiv.data('simulation-v2');
            var objectName = 'simulation-v2-' + fundingType;

            if (typeof ajaxObjectList[objectName] !== 'undefined') {
                ajaxObjectList[objectName].abort();
                delete ajaxObjectList[objectName];
            }
            $('#selectedLegalInformation').html('');
            ajaxObjectList[objectName] = $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                data: data,
                success: function (response) {
                    propositions[fundingType] = response;
                    Funding.makeSimulationSuccessCallBack(fundingType, response);
                    if (FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT === fundingType ||
                        FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT === fundingType ||
                        FUNDING_TYPE_LONG_TERM_LEASING === fundingType
                    ){
                        Funding.updateSimulationLegaleInfos(response.legalMention, fundingType);
                        response.legalInfos = response.legalMention;
                    }
                    resolve(response);
                },
                error: function (response) {
                    Funding.makeSimulationErrorCallBack(fundingType, response);
                    propositions[fundingType] = undefined;
                    if (FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT === fundingType || FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT === fundingType){
                        Funding.updateSimulationLegaleInfos('', fundingType);
                    }
                    reject();
                }
            });
        });
    }

    /**
     *
     * @param fundingType
     * @param data
     */
    static makeSimulationSuccessCallBack(fundingType, data){
        var card= $('#proposition-' + fundingType);
        card.find('.bloc-monthyPayment').show();
        Funding.updateCarView(card, data);
        Funding.hideLoader(card);
    }

    /**
     *
     * @param fundingType
     * @param request
     */
    static makeSimulationErrorCallBack(fundingType, request){
        var card= $('#proposition-' + fundingType);
        card.find('.info-error').show();
        card.find('.info-error span').html(request.responseJSON);
        Funding.hideLoader(card);
    }

    /**
     *
     * @param $container
     * @param data
     */
    static updateCarView($container, data){
        $container.find('.prixFinancement').show();
        const formatNumber = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});
        let montantTotalDu = '';
        let annualPercentRate = null;
        switch (data.fundingType) {
            case FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT:
                montantTotalDu = data.totalTTC;
                annualPercentRate = data.annualPercentageRate;
                $container.find('.monthyPayment').html(formatNumber.format(data.monthlyPayment));
                break;
            case FUNDING_TYPE_LONG_TERM_LEASING:
                montantTotalDu = data.totalTTCAllInclusive;
                $container.find('.monthyPayment').html(formatNumber.format(data.totalMonthlyPayment));
                break;
            case FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT:
            case FUNDING_TYPE_LEASING_WITHOUT_REPURCHASE_COMMITMENT:
                const durationInMonth = data.durationInMonth - (data.depositAmount > 0 ? 1 : 0);
                const depositAmountInsuranceNotIncludedTaxIncluded = data.depositAmount - data.prestationMonthlyPayment;
                const totalCostLeasing = data.monthlyPayment * durationInMonth + depositAmountInsuranceNotIncludedTaxIncluded;
                montantTotalDu = totalCostLeasing;
                $container.find('.monthyPayment').html(formatNumber.format(data.monthlyPayment));
                break;
        }
        $container.find('.mentionsLegalesFinancement').show();
        $('#'+data.fundingType+'-MontantTotalDu').html(formatNumber.format(montantTotalDu));
        $('#'+data.fundingType+'-duration').html(data.durationInMonth);
        if (annualPercentRate !== null) {
            $('#'+data.fundingType+'-TAEG').html(formatNumber.format(annualPercentRate)+'%');
        }
    }

    /**
     *
     * @param legalMentions
     * @param fundingType
     * @param data
     */
    static updateSimulationLegaleInfos(legalMentions, fundingType){
                let infoBulleDom = document.querySelector('#infobulle-' + fundingType);
                        if (fundingType === $('.chosenFundingProposition:checked').data('type')){
                            $('#selectedLegalInformation').html(legalMentions);
                        }
                        infoBulleDom.dataset.originalTitle = legalMentions;
    }

    /**
     *
     * @param data
     * @param fundingType
     * @returns {Promise}
     */
    static updateSimulationLegaleInfosRequest(data, fundingType){
        let url = $fundingInfosDiv.data('infos-bulle-v2');
        let objectName = 'infos-bulle-v2-' + fundingType;

        if (typeof ajaxObjectList[objectName] !== 'undefined') {
            ajaxObjectList[objectName].abort();
            delete ajaxObjectList[objectName];
        }

        return new Promise((resolve, reject) => {
            ajaxObjectList[objectName] = $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function (response) {
                    // returnValue = response;
                    resolve(response);
                },
                error: function () {
                    reject('Erreur de chargement de la mention légale');
                }
            });
        });
    }


    static formatNumber(number) {
        return new Intl.NumberFormat('fr-FR').format(number).replace(',', '.');
    }

    // region LOADER
    /**
     * @param $container
     * @param priceSelector
     */
    static showLoader($container, priceSelector) {
        var $price = $container.find(typeof priceSelector === 'undefined' ? '.prixFinancement' : priceSelector);
        var $loader = $container.find('.loadingFundingSimulation');
        $container.find('.mentionsLegalesFinancement').hide();
        $price.stop().hide();
        $loader.stop().fadeTo(750, 1);
    }

    /**
     *
     * @param $container
     * @param priceSelector
     */
    static hideLoader($container, priceSelector) {
        var $price = $container.find(typeof priceSelector === 'undefined' ? '.prixFinancement' : priceSelector);
        var $loader = $container.find('.loadingFundingSimulation');
        $loader.stop().hide();
        $price.stop().fadeTo(750, 1);
    }
// endregion
}

$(document).ready(function () {

    $apport = $('#financementApport');
    $prixDeVenteTotalWithPromo = $('#prix-de-vente-total-promo');
    $prixDeVenteTotal = ($prixDeVenteTotalWithPromo.length > 0) ? $prixDeVenteTotalWithPromo : $('#prix-de-vente-total');
    $prixVehiculeEmotors = $('#prix-emotors');
    $prixOptions = $('#vos-options');
    $prixCouleurInterieure = $('#recap-interior-color');
    $prixCouleurExterieure = $('#recap-exterior-color');
    $prixOptions = $prixOptions.length > 0 ? $prixOptions : null;
    $prixCouleurInterieure = $prixCouleurInterieure.length > 0 ? $prixCouleurInterieure : null;
    $prixCouleurExterieure = $prixCouleurExterieure.length > 0 ? $prixCouleurExterieure : null;

    $fundingInfosDiv = $('#funding-infos');
    $chosenFundingPropositionBtn = $('.chosenFundingProposition');

    initDurationSlider('#financementApport', 500);
    initDurationSlider('#financementDuree-long_term_leasing', 12);
    initDurationSlider('#financementDuree-leasing_without_repurchase_commitment', 12);
    initDurationSlider('#financementDuree-leasing_with_repurchase_commitment', 12);
    initDurationSlider('#financementDuree-loan_without_repurchase_commitment', 12);
    initDurationSlider('#financementAnnualMileAge-long_term_leasing', 5000);
    initDurationSlider('#financementAnnualMileAge-leasing_without_repurchase_commitment', 5000);
    initDurationSlider('#financementAnnualMileAge-leasing_with_repurchase_commitment', 5000);

    $apport.on('slideStop', function () {
        Funding.makeAllSimulations();
    });

    $prixDeVenteTotal.bind('contentchanged', function () {
        Funding.makeAllSimulations();
    });

    $chosenFundingPropositionBtn.click(function () {
        $('#selectedLegalInformation').html('');
        if (Object.keys(propositions).length === 0){
            Funding.makeAllSimulations();
        } else {
            switch ($(this).data('type')) {
                case FUNDING_TYPE_LOAN_WITHOUT_REPURCHASE_COMMITMENT:
                    Funding.makeLOANSimulation();
                    break;
                case FUNDING_TYPE_LEASING_WITH_REPURCHASE_COMMITMENT:
                    Funding.makeLOASimulation();
                    break;
                case FUNDING_TYPE_LONG_TERM_LEASING:
                    Funding.makeLLDSimulation();
                    break;
            }
        }
    });

    $('#financementDuree-long_term_leasing,#financementAnnualMileAge-long_term_leasing').on('slideStop', function () {
        if (Object.keys(propositions).length === 0){
            Funding.makeAllSimulations();
        } else {
            Funding.makeLLDSimulation();
        }
    });

    $('#financementDuree-leasing_with_repurchase_commitment,#financementAnnualMileAge-leasing_with_repurchase_commitment').on('slideStop', function () {
        if (Object.keys(propositions).length === 0){
            Funding.makeAllSimulations();
        } else {
            Funding.makeLOASimulation();
        }
    });

    $('#financementDuree-loan_without_repurchase_commitment,#financementAnnualMileAge-loan_without_repurchase_commitment').on('slideStop', function () {
        if (Object.keys(propositions).length === 0){
            Funding.makeAllSimulations();
        } else {
            Funding.makeLOANSimulation();
        }
    });
});

function initDurationSlider(id, step) {
    if ($(id).length > 0){
        let slider = $(id).slider({
            tooltip: 'hide',
            step: step,
            formatter: function (value) {
                return value + ' mois';
            }
        }).on('change', function (event) {
            $(event.currentTarget).parent().find('.fundingParameterValue').html($(event.currentTarget).val());
        });

        $(slider.slider('getElement')).addClass('fundingSlider');
        $(id).parent().find('.fundingParameterValue').html($(id).val());
    }
}
